import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface EhOfflineDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  alreadyRefreshed?: boolean;
}

export function EhOfflineDialog({ open, onOpenChange, alreadyRefreshed }: EhOfflineDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[425px] bg-zinc-900 border-none"
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>You Appear to Be Offline</DialogTitle>
          <DialogDescription>
            <span>Please check your internet connection to enjoy the app.</span>
            <br />
            {!alreadyRefreshed && (
              <span>The app will automatically reload once you're back online.</span>
            )}
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
} 